export const parseWashroomAnswers = (data: any) => {
  const answers: any = {};

  answers.basin_tap_count = {
    count: Object.keys(data?.taps || {}).length,
    groups: [],
  };

  Object.values(data?.taps || {}).forEach((tap: any) => {
    answers.basin_tap_count.groups.push({
      tap_type: tap.type || '',
      tap_leak: tap.leak || '',
      tap_leak_flow: tap.flowrate || '',
    });
  });

  answers.toilet_count = {
    count: Object.keys(data?.toilets || {}).length,
    groups: [],
  };

  Object.values(data?.toilets || {}).forEach((toilet: any) => {
    answers.toilet_count.groups.push({
      toilet_type: toilet.type || '',
      toilet_leak_flow: toilet.leak || '',
    });
  });

  answers.urinal_count = {
    count: Object.keys(data?.urinals || {}).length,
    groups: [],
  };

  Object.values(data?.urinals || {}).forEach((urinal: any) => {
    answers.urinal_count.groups.push({
      urinal_type: urinal.type || '',
      urinal_leak_flow: urinal.leak || '',
    });
  });

  answers.shower_count = {
    count: Object.keys(data?.showers || {}).length,
    groups: [],
  };

  Object.values(data?.showers || {}).forEach((shower: any) => {
    answers.shower_count.groups.push({
      shower_type: shower.type || '',
      shower_leak: shower.leak || '',
      shower_control: shower.control || '',
      showers_per_week: data.showers_per_week || 0,
    });
  });

  return answers;
};
